import React from 'react';
import styled from 'styled-components';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { IconChevronDown, ICON_ARROW_BLACK_TOP } from 'assets/icons';
import { QnaFilter } from '../../QnaList/hooks/useQnaListHooks';

const CountFilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  position: relative;

  cursor: pointer;
`;

const CountFilterItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;

  position: absolute;
  top: 28px;
  right: -4px;
  z-index: 10;

  width: max-content;
  padding: 16px 20px;

  border-radius: 12px;
  background: var(--Static-White, #fff);
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
`;

interface TotalCountContainerIProps {
  isOpenCountFilter: boolean;
  filterItem: QnaFilter | any;
  handleSetFilterItem: (key: string, value: any) => void;
  handleIsOpenCountFilter: () => void;
}

const PageSizeSelector = ({
  isOpenCountFilter,
  filterItem,
  handleSetFilterItem,
  handleIsOpenCountFilter,
}: TotalCountContainerIProps) => {
  return (
    <>
      <CountFilterContainer onClick={() => handleIsOpenCountFilter()}>
        <IconChevronDown color="rgba(112, 115, 124, 1)" />

        <Text color="rgba(112, 115, 124, 1)">{filterItem.size}개씩 보기</Text>
        {isOpenCountFilter && (
          <CountFilterItemContainer>
            <Text
              color="#343536"
              onClick={() => {
                handleSetFilterItem('size', 5);
                handleIsOpenCountFilter();
              }}
              style={{ cursor: 'pointer' }}
            >
              5개씩 보기
            </Text>
            <Text
              color="#46474c"
              onClick={() => {
                handleSetFilterItem('size', 10);
                handleIsOpenCountFilter();
              }}
              style={{ cursor: 'pointer' }}
            >
              10개씩 보기
            </Text>
            <Text
              color="#46474c"
              onClick={() => {
                handleSetFilterItem('size', 20);
                handleIsOpenCountFilter();
              }}
              style={{ cursor: 'pointer' }}
            >
              20개씩 보기
            </Text>
            <Text
              color="#46474c"
              onClick={() => {
                handleSetFilterItem('size', 50);
                handleIsOpenCountFilter();
              }}
              style={{ cursor: 'pointer' }}
            >
              50개씩 보기
            </Text>
          </CountFilterItemContainer>
        )}
      </CountFilterContainer>
    </>
  );
};

export default PageSizeSelector;
